/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartRunningAggregate = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M4 20v-1.6L9.5 12h6l6.3-7.3-1.6-1.4-5.7 6.7h-6L4 15.3V2H2v20h20v-2z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgChartRunningAggregate as ChartRunningAggregate };
